import Page from "@/components/layout/Page";

export default function DementiaAging() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Dementia and aging</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Read feedback from families and professionals using our products in dementia care.
            </p>
            
            <p className="text-lg leading-relaxed">
              Families and care professionals report that Samboards help individuals with dementia feel calmer and more engaged. The tactile sensory boards provide comfort during moments of confusion and offer meaningful activity that supports cognitive function and emotional wellbeing.
            </p>
            
            <p className="text-lg leading-relaxed">
              Carers appreciate having practical tools that reduce agitation and provide positive sensory experiences for their loved ones living with dementia and age-related conditions.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
